import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Vm
 *
 * Vm을 설명하세요.
 */
export const Vm = types
  .model('Vm')
  // --------------------------------------------------------------------------
  .props({
    vmSid: types.identifierNumber,
    vmNm: types.optional(types.string, ''), // 서버이름
    vmStts: types.maybeNull(types.string), // 상태
    vmSpec: types.maybeNull(types.string), // 스펙 (CPU/RAM)
    vmPublIp: types.maybeNull(types.string), // 공인 IP
    vmPrvtIp: types.maybeNull(types.string), // 내부 IP
    zoneInfo: types.maybeNull(types.string), // Zone

    useYn: types.optional(types.string, 'Y'),
    delYn: types.optional(types.string, 'N'),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model vm --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IVm;
      (Object.keys(newProps) as TVmKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TVm = Instance<typeof Vm>;
type TVmSnapshot = SnapshotOut<typeof Vm>;

export interface IVm extends TVm {}
export type TVmKeys = keyof TVmSnapshot & string;
export interface IVmSnapshot extends TVmSnapshot {}
export const createVm = () => types.optional(Vm, {} as TVm);
